import { Modal } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import { X } from "lucide-react";

// One row per landlord: how many of their cases need Ops action.
const groupByLandlord = (workspaces = []) => {
  const byLandlord = new Map();
  workspaces.forEach((entry) => {
    const key = String(entry.landlord_id ?? "");
    const current = byLandlord.get(key) || {
      landlord_id: entry.landlord_id,
      landlord: entry.landlord,
      total: 0,
    };
    current.total += entry.total || 0;
    byLandlord.set(key, current);
  });
  return [...byLandlord.values()].sort((a, b) => b.total - a.total);
};

const NeedsOpsSummaryModal = ({ show, onHide, summary, loading, onOpen }) => {
  const landlords = groupByLandlord(summary?.workspaces);

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      scrollable
      className="landlord-metrics-modal"
    >
      <Modal.Header className="landlord-details-header">
        <div className="d-flex justify-content-between align-items-start w-100">
          <div>
            <h4 className="landlord-details-name">Needs ops action</h4>
            <p className="landlord-details-email">
              {loading ? "…" : summary?.total || 0} pending
            </p>
          </div>
          <button className="modal-close-btn" onClick={onHide}>
            <X size={20} />
          </button>
        </div>
      </Modal.Header>
      <Modal.Body className="px-4 pb-4 pt-3">
        {loading ? (
          <p className="text-muted text-center py-5">Loading…</p>
        ) : landlords.length === 0 ? (
          <p className="text-muted text-center py-5">
            Nothing needs Ops action right now.
          </p>
        ) : (
          <Table hover className="landlord-modal-table mb-0">
            <thead>
              <tr>
                <th>LANDLORD</th>
                <th className="text-center">TOTAL</th>
                <th className="text-center">ACTION</th>
              </tr>
            </thead>
            <tbody>
              {landlords.map((entry) => (
                <tr key={String(entry.landlord_id)}>
                  <td>
                    <div className="tenant-name-stack">
                      <span className="tenant-name">
                        {entry.landlord?.name || "N/A"}
                      </span>
                      {entry.landlord?.email && (
                        <span className="tenant-email">
                          {entry.landlord.email}
                        </span>
                      )}
                    </div>
                  </td>
                  <td className="text-center">
                    <span className="ip-needs-ops-badge ip-needs-ops-badge--static">
                      {entry.total}
                    </span>
                  </td>
                  <td className="text-center">
                    <button
                      type="button"
                      className="ip-action-btn"
                      onClick={() => onOpen?.(entry)}
                    >
                      Open
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default NeedsOpsSummaryModal;
